import { win } from "src/global";
import { isFunction } from "src/utils";

let contextCache: {
  userid: string,
  username: string,
  pdl: string,
  ytid: string,
} = null;
export async function getContext() {
  const jDiwork: any = win.jDiwork;

  if(contextCache) {
    return contextCache;
  }
  if(jDiwork && isFunction(jDiwork.getContext)) {
    await new Promise((resolve) => {
      jDiwork.getContext((ctx) => {
        if (ctx) {
          contextCache = {
            userid: ctx.userid,
            username: ctx.username,
            pdl: ctx.productLine,
            ytid: ctx.ytenantId,
          };
        } else {
          hbLogger.debug('jDiwork.getContext!!', ctx);
        }
        resolve(contextCache);
      });
    });
    return contextCache;
  }
  return null;
}
let jDworkStateCache = null;
export async function getJdworkState() {
  const jDiwork: any = win.jDiwork;

  if(jDworkStateCache) {
    return jDworkStateCache;
  }
  if(jDiwork && isFunction(jDiwork.getState)) {
    jDworkStateCache = new Promise((resolve) => {
      const reslv = (state) => {
        resolve(state);
        if (state) {
          setTimeout(() => {
            jDworkStateCache = null;
          }, 100);
        } else {
          hbLogger.debug('jDiwork.getState!!', state);
          jDworkStateCache = null;
        }
      };
      const timer = setTimeout(() => {
        reslv({});
      }, 800);
      jDiwork.getState((state) => {
        clearTimeout(timer);
        reslv(state);
      });
    });
  }
  return jDworkStateCache;
}
